import { defineMessages } from 'react-intl';

export default defineMessages({
  allProducts: {
    id: 'components.BundlePrice.allProducts',
    defaultMessage: 'All Products',
  },
  bundlePrice: {
    id: 'components.BundlePrice.bundlePrice',
    defaultMessage: 'Bundle Price',
  },
  update: {
    id: 'components.ProductPrice.license.update',
    defaultMessage: 'Update',
  },
  youSave: {
    id: 'components.BundlePrice.youSave',
    defaultMessage: 'You save',
  },
  buyNow: {
    id: 'common.button.buyNow',
    defaultMessage: 'Buy now',
  },
});
